/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Website API
 * The backend API for the website SPA
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/react-query'
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import * as axios from 'axios';
import type {
  AxiosError,
  AxiosRequestConfig,
  AxiosResponse
} from 'axios'
import type {
  ImageLookupRequest,
  ImageLookupResponse
} from './data.schemas'




export const lookupFiles = (
    imageLookupRequest: ImageLookupRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ImageLookupResponse>> => {
    
    return axios.default.post(
      `/api/image/lookup`,
      imageLookupRequest,options
    );
  }


export const getLookupFilesQueryKey = (imageLookupRequest: ImageLookupRequest,) => {
    return [`/api/image/lookup`, imageLookupRequest] as const;
    }

    
export const getLookupFilesQueryOptions = <TData = Awaited<ReturnType<typeof lookupFiles>>, TError = AxiosError<unknown>>(imageLookupRequest: ImageLookupRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lookupFiles>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLookupFilesQueryKey(imageLookupRequest);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof lookupFiles>>> = ({ signal }) => lookupFiles(imageLookupRequest, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn,   staleTime: 3600000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof lookupFiles>>, TError, TData> & { queryKey: QueryKey }
}

export type LookupFilesQueryResult = NonNullable<Awaited<ReturnType<typeof lookupFiles>>>
export type LookupFilesQueryError = AxiosError<unknown>

export const useLookupFiles = <TData = Awaited<ReturnType<typeof lookupFiles>>, TError = AxiosError<unknown>>(
 imageLookupRequest: ImageLookupRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lookupFiles>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getLookupFilesQueryOptions(imageLookupRequest,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



